import axios from "axios";
import { ElMessage } from "element-plus";

let url = '';
if (process.env.NODE_ENV == 'development') {
  url = process.env.VUE_APP_BASE_URL;
  // url = JSON.parse(process.env.VUE_APP_BASE_URL)[0][1]
} else if (process.env.NODE_ENV == 'production') {
  url = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API
}

// 创建 axios 实例
const service = axios.create({
  baseURL: url,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "Access-Control-Allow-Origin": "*",
    "Content-Security-Policy-Report-Only": "default-src 'self';report-uri /some-report-uri;",
  },
})

// 请求拦截
service.interceptors.request.use(
  config => {
    // 可添加请求头等信息
    return config;
  },
  error => {
    // 请求处理
    return Promise.reject(error);
  }
)

// 响应拦截
service.interceptors.response.use(
  response => {
    // 对响应数据做处理
    // 检查配置的响应类型是否为二进制类型（'blob' 或 'arraybuffer'）, 如果是，直接返回响应对象
    if (
      response.config.responseType === "blob" ||
      response.config.responseType === "arraybuffer"
    ) {
      return response;
    }
    // 根据返回状态码作出相应处理
    const { code, data, msg	 } = response.data;
    if (code === '00000') {
      return data;
    } else if (code === '4001') {
      ElMessage.success(msg);
      return;
    }
    
    ElMessage.error(msg || "系统出错");
    // return Promise.reject(new Error(message || "Error"));
    return;
  },
  error => {
    // 相应错误处理
    // console.log('error', error.config)
    // return Promise.reject(error);
    // if (error.config.url == '/programParams/toRTools') return;

    ElMessage.error(error);
    return;
  }
)

// 导出 axios 实例
export default service;